import React from "react";
import { EMAIL_TEMPLATES, EmailTemplate } from "../data";
import TemplateCard from "../TemplateCard";

import styles from "./index.module.scss";

interface TemplateGridProps {
  onPick: (template: EmailTemplate) => void;
}

/**
 * Every template, three across.
 *
 * Used by the dialog the Create button opens. The builder's own Templates panel
 * is the exception — it is 280px wide and holds its own two-up grid.
 */
export default function TemplateGrid({ onPick }: TemplateGridProps) {
  return (
    <div className={styles.grid}>
      {EMAIL_TEMPLATES.map((template) => (
        <TemplateCard key={template.id} template={template} onPick={onPick} />
      ))}
    </div>
  );
}
